import { DetailSectionItem } from '@sr/types/';
import { List, ListItem, Paragraph } from './ui';

// Matches lines starting with bullets and space around them
const bulletRegex = /^\s*[•-]\s*/g;

type Props = Pick<DetailSectionItem, 'summary'>;

// Legacy summary string rendering (string with markdown bullet support)
const SummaryLegacy = ({ summary }: Props) => {
  const output = [];
  let chunks = summary.split('\n');
  chunks = chunks.filter((chunk) => chunk !== '');
  // Don't render anything if there is no content
  if (!chunks.length) return null;

  for (let i = 0; i < chunks.length; i++) {
    if (bulletRegex.test(chunks[i])) {
      const listItems = [];
      let endingParagraph = null;

      for (i; i < chunks.length; i++) {
        // No idea why, but bulletRegex.test(chunks[i]) wasnt working here...
        const matches = chunks[i].match(bulletRegex);

        if (matches !== null) {
          listItems.push(chunks[i].replace(bulletRegex, ''));
        } else {
          endingParagraph = chunks[i];
          break;
        }
      }

      output.push(
        <List variant="summaryList" key={i}>
          {listItems.map((item, index) => (
            <ListItem variant="summaryListItem" key={index}>
              {item}
            </ListItem>
          ))}
        </List>
      );

      if (endingParagraph) {
        output.push(<Paragraph key={`${i}p`}>{endingParagraph}</Paragraph>);
      }
    } else if (chunks[i] !== '') {
      output.push(<Paragraph key={i}>{chunks[i]}</Paragraph>);
    }
  }

  return <div>{output}</div>;
};

export default SummaryLegacy;
